export default __webpack_public_path__ + "static/media/chaveSetaConsorcio.43bb7734.svg";